/* eslint-disable react/jsx-no-target-blank */
import {Link, useLocation} from 'react-router-dom'
import {KTIcon, checkIsActive} from '../../../helpers'
import clsx from 'clsx'

const SidebarFooter = () => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, '/status')

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <Link
        to='/status-page'
        className={clsx(
          'btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100',
          {active: isActive}
        )}
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='Status Page'
        style={{opacity: 1}}
      >
        <span className='btn-label'>Status Page</span>
        <KTIcon iconName='server' className='btn-icon fs-2 m-0' />
      </Link>
    </div>
  )
}

export {SidebarFooter}
